import {SxProps, Theme} from "@mui/material";

// Shared MUI styling for the guest auth (login / register) inputs so both
// forms render the same white, borderless-ish, rounded 14px / 46px fields with
// small uppercase external labels. Scoped to the auth forms to avoid touching
// the global theme.
export const authInputSx: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#ffffff',
    borderRadius: '14px',
    minHeight: 46,
    fontSize: 15,
    '& fieldset': {
      borderColor: 'rgba(27, 32, 53, 0.08)',
    },
    '&:hover fieldset': {
      borderColor: 'rgba(27, 32, 53, 0.18)',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#1b2035',
      borderWidth: '1.5px',
    },
  },
  '& .MuiOutlinedInput-input': {
    padding: '12px 16px',
  },
  '& .MuiOutlinedInput-input::placeholder': {
    color: '#9aa1b2',
    opacity: 1,
  },
};
